import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClockRotateLeft } from '@fortawesome/free-solid-svg-icons';

function navigateToPrevious(history, url) {
    // Validate URL to prevent XSS
    if (url.startsWith('javascript:') || url.startsWith('data:')) {
        console.warn('Blocked potentially malicious URL:', url);
        return;
    }

    // check if full path or only route is saved
    if (url.startsWith('http')) {
        try {
            new URL(url); // Validates URL format
            window.open(url, '_blank'); // full path indicates team or care; open in new tab
        } catch (e) {
            console.error('Invalid URL:', url);
        }
    } else {
        history.push(url); // only route indicates internal to account
    }
}

const PickUpFromLastScreen = ({ classes }) => {
    const [previousPageTitle, setPreviousPageTitle] = useState('');
    const [resumeUrl, setResumeUrl] = useState('');
    const [showResume, setShowResume] = useState(true);
    const history = useHistory();

    useEffect(() => {
        async function fetchCookie() {
            const savedLocation = await cookieStore.get('platform_resume');
            if (savedLocation) {
                const decodedCookie = decodeURIComponent(savedLocation.value);
                const splitName = decodedCookie.split(' - ');
                setPreviousPageTitle(splitName[0]);
                setResumeUrl(splitName[1]);
            } else {
                setShowResume(false);
            }
        }
        fetchCookie();
    }, []);

    return (
        <div className={classes["pickup-wrapper"]} hidden={!showResume}>
            <div className={classes["pickup-left-wrap"]}>
                <span>
                    <FontAwesomeIcon icon={faClockRotateLeft} />
                </span>
                <span>
                    <div className={classes["pickup-title"]}>Pick Up Where You Left Off</div>
                    <div className={classes["pickup-desc"]}>{previousPageTitle}</div>
                </span>
            </div>
            <button type="button" className={classes["resume-btn"]} onClick={() => { navigateToPrevious(history, resumeUrl) }}>Resume</button>
        </div>
    )
}

export default PickUpFromLastScreen;